import React from "react"
import { Flex } from "rebass"
import { ExternalLink } from "@fragments"

const TutorialList = ({ data, noJustify }) => (
  <Flex flexWrap="wrap" justifyContent={noJustify ? "auto" : "space-between"}>
    {data.map((tutorial, index) => {
      return (
        <Flex
          key={index}
          width={[0.45, 0.31]}
          ml={noJustify && index === data.length - 1 ? 30 : 0}
        >
          <Flex flexDirection="column">
            {tutorial.image && (
              <ExternalLink to={tutorial.link} aria-label={tutorial.title} noStyle>
                <img
                  src={`/images/tools/${tutorial.image}.png`}
                  alt=""
                  width={400}
                  height={300}
                  loading="lazy"
                  decoding="async"
                  className="shadow-hover"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "rgba(0, 0, 0, 0.15) 3px 4px 10px 4px",
                  }}
                />
              </ExternalLink>
            )}
            <ExternalLink href={tutorial.link} noStyle>
              <h3 style={{ fontSize: "1rem", lineHeight: "1.5", marginTop: "6px" }}>
                {tutorial.title}
              </h3>
            </ExternalLink>
          </Flex>
        </Flex>
      )
    })}
  </Flex>
)

export default TutorialList
